import * as providers from "@ethersproject/providers";
export const fetchENSAddressForDomain = (name, provider) => {
    const ethProvider = provider || providers.getDefaultProvider();
    return ethProvider.resolveName(name);
};
